export const UpdateFundActionTypes = {
  UPDATE_FUND_LOADING: "UPDATE_FUND_LOADING",
  UPDATE_FUND_ERROR: "UPDATE_FUND_ERROR",
  UPDATE_FUND_SUCCESS: "UPDATE_FUND_SUCCESS",
};
